function customSidebarStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, vertical_breakpoints, borders } = theme;
    const { transparentInfo, sidebarState, deviceStyle, miniNavbar } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    const { values: { vxs, vsm, vmd, vlg, vxl, vxxl, vx3l } } = vertical_breakpoints;

    if (sidebarState == 'landing') {
        var max_width = deviceStyle == 'mobile' ? 'unset' : pxToRem(860);

        return {
            [breakpoints.up('xxs')]: {
                height: 'calc(100vh - 24px)',
            },
            [breakpoints.up('xs')]: {
                height: 'calc(100vh - 76px)',
            },
            [breakpoints.up('xl')]: {
                [`@media (min-height:${vxs}px)`]: {
                    height: '40vh',
                },
                [`@media (min-height:${vsm}px)`]: {
                    height: '51vh',
                },
                [`@media (min-height:${vmd}px)`]: {
                    height: '58vh',
                },
                [`@media (min-height:${vlg}px)`]: {
                    height: '65vh',
                },
                [`@media (min-height:${vxl}px)`]: {
                    height: '68vh',
                },
                [`@media (min-height:${vxxl}px)`]: {
                    height: '66vh',
                }
            },
            maxWidth: max_width,

            "& > *": {
                transition: transitions.create("all", {
                    easing: transitions.easing.easeInOut,
                    duration: transitions.duration.standard,
                }),
            },

            "& .MuiToolbar-root": {
                [breakpoints.up("xxs")]: {
                    minHeight: "auto",
                },
            },

            transition: `width 300ms ease-in-out, height 300ms ease-in-out`,
        };
    }
    else if (sidebarState == 'exploring') {
        var max_width = deviceStyle == 'mobile' ? 'unset' : pxToRem(860);

        return {
            [breakpoints.up('xxs')]: {
                height: miniNavbar ? 'auto' : 'inherit',
            },
            [breakpoints.up('xl')]: {
                [`@media (min-height:${vxs}px)`]: {
                    height: '40vh',
                },
                [`@media (min-height:${vsm}px)`]: {
                    height: '51vh',
                },
                [`@media (min-height:${vmd}px)`]: {
                    height: '58vh',
                },
                [`@media (min-height:${vlg}px)`]: {
                    height: '65vh',
                },
                [`@media (min-height:${vxl}px)`]: {
                    height: '68vh',
                },
                [`@media (min-height:${vxxl}px)`]: {
                    height: '66vh',
                },
            },

            maxWidth: max_width,
            "& > *": {
                transition: transitions.create("all", {
                    easing: transitions.easing.easeInOut,
                    duration: transitions.duration.standard,
                }),
            },

            "& .MuiToolbar-root": {
                [breakpoints.up("xxs")]: {
                    minHeight: "auto",
                },
            },

            transition: `width 300ms ease-in-out, height 300ms ease-in-out`,
        };
    }
    else if (sidebarState == 'sidenav') {
        return {
            // height: '90vh',
            // marginLeft: 'inherit',
            // maxWidth: 300,
            height: '100%',


            // minHeight: 0,

            "& > *": {
                transition: transitions.create("all", {
                    easing: transitions.easing.easeInOut,
                    duration: transitions.duration.standard,
                }),
            },

            "& .MuiToolbar-root": {
                [breakpoints.up("sm")]: {
                    minHeight: "auto",
                    padding: `${pxToRem(4)} ${pxToRem(16)}`,
                },
            },

            transition: `width 300ms ease-in-out, height 300ms ease-in-out`,
        };
    }
}

function sidebarTabStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { transparentInfo, sidebarState, hot_pink, deviceStyle } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, rgb, pxToRem } = functions;
    const { borderRadius } = borders;

    if (sidebarState == 'landing' || sidebarState == 'exploring') {
        if (hot_pink) {
            return {
                boxShadow: navbarBoxShadow,
                backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                backgroundColor: rgba('#ff27f4', 1),
                color: '#ff27f4',
                borderRadius: borderRadius.xl,

                paddingTop: deviceStyle == 'mobile' ? pxToRem(8) : pxToRem(16),
                paddingBottom: deviceStyle == 'mobile' ? pxToRem(8) : pxToRem(32),
                paddingRight: deviceStyle == 'mobile' ? pxToRem(8) : pxToRem(32),
                paddingLeft: deviceStyle == 'mobile' ? pxToRem(8) : pxToRem(32),

                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                pointerEvents: 'auto',

                "& > *": {
                    transition: transitions.create("all", {
                        easing: transitions.easing.easeInOut,
                        duration: transitions.duration.standard,
                    }),
                },
            };
        }
        else {
            return {
                boxShadow: navbarBoxShadow,
                backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                backgroundColor: rgba(white.main, 0.8),
                color: white.main,
                borderRadius: borderRadius.xl,

                paddingTop: deviceStyle == 'mobile' ? pxToRem(8) : pxToRem(16),
                paddingBottom: deviceStyle == 'mobile' ? pxToRem(8) : pxToRem(32),
                paddingRight: deviceStyle == 'mobile' ? pxToRem(8) : pxToRem(32),
                paddingLeft: deviceStyle == 'mobile' ? pxToRem(8) : pxToRem(32),

                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                pointerEvents: 'auto',

                "& > *": {
                    transition: transitions.create("all", {
                        easing: transitions.easing.easeInOut,
                        duration: transitions.duration.standard,
                    }),
                },
            };
        }
    }
    else if (sidebarState == 'sidenav') {
        return {
            boxShadow: navbarBoxShadow,
            backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
            color: white.main,
            borderRadius: borderRadius.xl,
            height: '100%',
            overflowY: 'auto',

            paddingTop: pxToRem(16),
            paddingBottom: pxToRem(32),
            paddingRight: pxToRem(32),
            paddingLeft: pxToRem(32),

            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            pointerEvents: 'auto',

            '::-webkit-scrollbar': {
                backgroundColor: 'transparent',
                width: '8px',
            },
            '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                backgroundColor: 'transparent',
            },
            '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                backgroundColor: '#babac0',
                borderRadius: '6px',
                border: `1px solid ${rgba(white.main, 0.8)}`,
            },
            '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                display: 'none',
            },

            "& .MuiToolbar-root": {
                [breakpoints.up("sm")]: {
                    minHeight: "auto",
                    padding: `${pxToRem(4)} ${pxToRem(16)}`,
                },
            },

            transition: `width 300ms ease-in-out`,
        };
    }
}

function sidebarToggleStyle(theme, ownerState) {
    const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { sidebarState } = ownerState;

    const { dark, white, text, transparent } = palette;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    if (sidebarState == 'landing' || sidebarState == 'exploring') {
        return {
            boxShadow: "none",
            backdropFilter: true ? "none" : `saturate(200%) blur(${pxToRem(4)})`,
            backgroundColor: rgba(white.main, 0.8),
            borderRadius: borderRadius.xl,
            minWidth: pxToRem(50),
            height: pxToRem(200),
            padding: pxToRem(8),
            cursor: 'pointer',
            pointerEvents: 'auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',

            "&:hover": {
                backgroundColor: '#CCCCCC !important',
            },

            transition: "background-color 300ms ease, color 300ms ease",
        };
    }
    else if (sidebarState == 'sidenav') {
        return {
            display: 'none',
            // boxShadow: "none",
            // backdropFilter: true ? "none" : `saturate(200%) blur(${pxToRem(4)})`,
            // backgroundColor: rgba(white.main, 0.8),
            // borderRadius: borderRadius.xl,
            // minWidth: pxToRem(50),
            // height: pxToRem(200),
            // padding: pxToRem(8),
            // cursor: 'pointer',
            // pointerEvents: 'auto',
            // display: 'flex',
            // flexDirection: 'column',
            // justifyContent: 'center',
            // alignItems: 'center',

            // "&:hover": {
            //     backgroundColor: '#CCCCCC !important',
            // },

            transition: "background-color 300ms ease, color 300ms ease, display 300ms ease-in-out",
        };
    }
}

function sidebarHeadersStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { transparentInfo, sidebarState } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular, fontWeightBold } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    if (sidebarState == 'landing' || sidebarState == 'exploring') {
        return {
            "& .userWelcome": {
                "& > *": {
                    [breakpoints.up('xxs')]: {
                        fontSize: typography.h5,
                    },
                    [breakpoints.up('lg')]: {
                        fontSize: typography.h4,
                    },
                    [breakpoints.up('xl')]: {
                        fontSize: typography.h3,
                    },
                    [breakpoints.up('xxl')]: {
                        fontSize: typography.h2,
                    },

                    textTransform: 'capitalize',
                    fontWeight: fontWeightBold,
                    transition: 'font-size 300ms ease-in-out'
                }
            },

            "& .subheading": {
                "& > *": {
                    [breakpoints.up('xxs')]: {
                        fontSize: typography.h6,
                    },
                    [breakpoints.up('xl')]: {
                        fontSize: typography.h5,
                    },

                    fontWeight: fontWeightRegular,
                    transition: 'font-size 300ms ease-in-out'
                }
            },



        };
    }
    else if (sidebarState == 'sidenav') {
        return {
            "& .userWelcome": {
                "& > *": {
                    [breakpoints.up('xxs')]: {
                        fontSize: typography.h5,
                    },
                    [breakpoints.up('x5l')]: {
                        fontSize: typography.h4,
                    },

                    textTransform: 'capitalize',
                    fontWeight: fontWeightBold,
                    transition: 'font-size 300ms ease-in-out'
                }
            },

            "& .subheading": {
                "& > *": {
                    [breakpoints.up('xxs')]: {
                        fontSize: size.sm,
                    },
                    [breakpoints.up('x5l')]: {
                        fontSize: size.md,
                    },

                    fontWeight: fontWeightRegular,
                    transition: 'font-size 300ms ease-in-out'
                }
            },
        };
    }

}

function exploreContentStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, vertical_breakpoints, borders } = theme;
    const { transparentInfo, sidebarState, miniNavbar } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular, fontWeightBold } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    const { values: { vxs, vsm, vmd, vlg, vxl, vxxl, vx3l } } = vertical_breakpoints;

    if (sidebarState == 'exploring') {
        return {
            [breakpoints.up('xxs')]: {
                display: miniNavbar ? 'none' : 'inherit',
                height: '100%',
            },
            // [breakpoints.up('xl')]: {
            //     [`@media (min-height:${vxs}px)`]: {
            //         height: '14vh',
            //     },
            //     [`@media (min-height:${vsm}px)`]: {
            //         height: '29vh',
            //     },
            //     [`@media (min-height:${vmd}px)`]: {
            //         height: '34vh',
            //     },
            //     [`@media (min-height:${vlg}px)`]: {
            //         height: '47vh',
            //     },
            //     [`@media (min-height:${vxl}px)`]: {
            //         height: '49vh',
            //     },
            //     [`@media (min-height:${vxxl}px)`]: {
            //         height: '50vh',
            //     },
            // },
        }
    }
}

export {
    customSidebarStyle,
    sidebarTabStyle,
    sidebarToggleStyle,
    sidebarHeadersStyle,
    exploreContentStyle
}